import { ScrapMixAnalysisPage } from "./ScrapMixAnalysisPage";

export default ScrapMixAnalysisPage;
